/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, GarageSpotFromJSON, GarageSpotToJSON, GarageSpotEquipmentStatusFromJSON, GarageSpotEquipmentStatusToJSON, } from './';
export function CarEquipmentFromJSON(json) {
    return CarEquipmentFromJSONTyped(json, false);
}
export function CarEquipmentFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'garageSpotId': !exists(json, 'garageSpotId') ? undefined : json['garageSpotId'],
        'garageSpot': !exists(json, 'garageSpot') ? undefined : GarageSpotFromJSON(json['garageSpot']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'quantity': !exists(json, 'quantity') ? undefined : json['quantity'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'addedDate': !exists(json, 'addedDate') ? undefined : (new Date(json['addedDate'])),
        'status': !exists(json, 'status') ? undefined : GarageSpotEquipmentStatusFromJSON(json['status']),
    };
}
export function CarEquipmentToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'garageSpotId': value.garageSpotId,
        'garageSpot': GarageSpotToJSON(value.garageSpot),
        'name': value.name,
        'description': value.description,
        'quantity': value.quantity,
        'location': value.location,
        'addedDate': value.addedDate === undefined ? undefined : (value.addedDate.toISOString()),
        'status': GarageSpotEquipmentStatusToJSON(value.status),
    };
}
